import { render, staticRenderFns } from "./Ofertas.vue?vue&type=template&id=4aaca304&"
import script from "./Ofertas.vue?vue&type=script&lang=js&"
export * from "./Ofertas.vue?vue&type=script&lang=js&"
import style0 from "./Ofertas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports